import type { IGrowthOverviewTableRow } from "../types";

export const collectSingleChildExpansionIds = (row: IGrowthOverviewTableRow): string[] => {
    const ids = [row.id];

    if (row.rowType !== "industry" || row.children?.length !== 1) {
        return ids;
    }

    const onlyChild = row.children[0];
    if (
        onlyChild.rowType === "sub-industry" &&
        ((onlyChild.children?.length ?? 0) > 0 || (onlyChild.domainCount ?? 0) > 0)
    ) {
        ids.push(onlyChild.id);
    }

    return ids;
};
